module.exports = __webpack_public_path__ + "static/img/technology_2.055be50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/technology_2.jpg
// module id = P7IZ
// module chunks = 0